import L from 'leaflet'

export const formatters = {
    methods: {
        formatDistance(value){
            let unit = 'მ';
            if(value >= 1000){
                value = value / 1000;
                unit = 'კმ';
            }
            value = this.roundAndFormat(value, 2);
            return value + ' ' + unit;
        },

        formatArea(value){
            let unit = 'კვ. მ';
            if(value >= 1000000){
                value = value / 1000000;
                unit = 'კვ. კმ';
            }
            value = this.roundAndFormat(value, 2);
            return value + ' ' + unit;
        },

        roundAndFormat(value, roundTo){
            value = this.roundNumber(value, roundTo);
            return this.addWhiteSpaces(value);
        },

        roundNumber(number, roundTo) {
            return Math.round(number * Math.pow(10, roundTo)) / Math.pow(10, 2);
        },

        addWhiteSpaces(value) {
            let parts = value.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            return parts.join(".");
        }
    }
};

export const fitters = {
    data(){
        return{
            fitMaxZoom: 18,
            fitAnimate: true
        }
    },
    methods:{
        fitAll(shapes = null){
            let allShapes = shapes ? shapes : this.findAllShapes();
            if(allShapes.length){
                let layerGroup = this.createLayerGroup(allShapes);
                this.fitLayers(layerGroup);
            }
        },

        createLayerGroup(layers){
            if(layers){
                let allLayers = L.featureGroup();
                if(Array.isArray(layers)){
                    layers.forEach(layer =>{
                        allLayers.addLayer(layer);
                    })
                }else if(layers.constructor === Object){
                    for(let key in layers){
                        allLayers.addLayer(layers[key]);
                    }
                }
                return allLayers;
            }
        },

        findAllShapes(){
            let shapes = [];
            if(this.mapObject){
                this.mapObject.eachLayer((layer)=>{
                    if(layer instanceof L.Marker || layer instanceof L.Polyline || layer instanceof L.Circle ){
                        shapes.push(layer)
                    }
                });
            }
            return shapes;
        },
        
        fitShape(shape){
            if(shape){
                let bounds = null;
                if(shape instanceof L.Marker){
                    bounds = L.latLngBounds([ shape.getLatLng() ]);
                }else{
                    bounds = shape.getBounds();
                }
                this.fit(bounds);
            }
        },

        fitLayers(layers){
            let allLayers = layers.getBounds();
            this.fit(allLayers);
        },

        fitPosition(position, zoom = this.fitMaxZoom){
            this.mapObject.panTo({lat: position.lat, lng: position.lng});
            this.mapObject.setZoom(zoom, {animate: this.fitAnimate});
        },

        fit(bounds){
            this.mapObject.fitBounds(bounds, {maxZoom: this.fitMaxZoom, animate: this.fitAnimate});
        }
    },
    computed:{
        mapObject(){
            return this.$store.state.map.mapObject;
        }
    }
};